import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    IconButton: {
        color: '#2a4361',
        background: '#f5f5f5',
        margin: '20px 3px 20px 0px',
        fontSize: '18px',
        padding: '10px'
    }
}));